import GenUtils from "../../common/GenUtils";
/**
 * Monero subaddress model.
 */
export default class MoneroSubaddress {
    constructor(subaddress) {
        Object.assign(this, subaddress);
        if (this.balance !== undefined && typeof this.balance !== "bigint")
            this.balance = BigInt(this.balance);
        if (this.unlockedBalance !== undefined && typeof this.unlockedBalance !== "bigint")
            this.unlockedBalance = BigInt(this.unlockedBalance);
    }
    toJson() {
        let json = Object.assign({}, this);
        if (json.balance !== undefined)
            json.balance = json.balance.toString();
        if (json.unlockedBalance !== undefined)
            json.unlockedBalance = json.unlockedBalance.toString();
        return json;
    }
    getAccountIndex() {
        return this.accountIndex;
    }
    setAccountIndex(accountIndex) {
        this.accountIndex = accountIndex;
        return this;
    }
    getIndex() {
        return this.index;
    }
    setIndex(index) {
        this.index = index;
        return this;
    }
    getAddress() {
        return this.address;
    }
    setAddress(address) {
        this.address = address;
        return this;
    }
    getLabel() {
        return this.label;
    }
    setLabel(label) {
        this.label = label;
        return this;
    }
    getBalance() {
        return this.balance;
    }
    setBalance(balance) {
        this.balance = balance;
        return this;
    }
    getUnlockedBalance() {
        return this.unlockedBalance;
    }
    setUnlockedBalance(unlockedBalance) {
        this.unlockedBalance = unlockedBalance;
        return this;
    }
    getNumUnspentOutputs() {
        return this.numUnspentOutputs;
    }
    setNumUnspentOutputs(numUnspentOutputs) {
        this.numUnspentOutputs = numUnspentOutputs;
        return this;
    }
    getIsUsed() {
        return this.isUsed;
    }
    setIsUsed(isUsed) {
        this.isUsed = isUsed;
        return this;
    }
    getNumBlocksToUnlock() {
        return this.numBlocksToUnlock;
    }
    setNumBlocksToUnlock(numBlocksToUnlock) {
        this.numBlocksToUnlock = numBlocksToUnlock;
        return this;
    }
    toString(indent = 0) {
        let str = "";
        str += GenUtils.kvLine("Account index", this.getAccountIndex(), indent);
        str += GenUtils.kvLine("Subaddress index", this.getIndex(), indent);
        str += GenUtils.kvLine("Address", this.getAddress(), indent);
        str += GenUtils.kvLine("Label", this.getLabel(), indent);
        str += GenUtils.kvLine("Balance", this.getBalance(), indent);
        str += GenUtils.kvLine("Unlocked balance", this.getUnlockedBalance(), indent);
        str += GenUtils.kvLine("Num unspent outputs", this.getNumUnspentOutputs(), indent);
        str += GenUtils.kvLine("Is used", this.getIsUsed(), indent);
        str += GenUtils.kvLine("Num blocks to unlock", this.getNumBlocksToUnlock(), indent);
        return str.slice(0, str.length - 1); // strip last newline
    }
}
